import {
    GESTION_OPERATIVA_ADD_BILLS_SUCCESS,
    GESTION_OPERATIVA_ADD_BILLS_FAILURE,
    GESTION_OPERATIVA_ADD_BILLS_DISMISS_ERROR,
    GESTION_OPERATIVA_ADD_BILLS_BEGIN
  } from '../constants'

export function reducer(state, action) {
    switch (action.type) {
      case GESTION_OPERATIVA_ADD_BILLS_SUCCESS:
        // The request is success
        return {
          ...state,
          billsPending: false,
          billsError: null,
          billsAction: 'added',
          sale: {
            ...state.sale,
            bill: action.data,
            sale_state: action.data?.Sale?.sale_state,
            Bills: [...state.sale.Bills, action.data]
          }
        }
  
      case GESTION_OPERATIVA_ADD_BILLS_FAILURE:
        // The request is failed
        return {
          ...state,
          billsError: action.data.error,
          billsAction: null,
          sale: { ...state.sale },
          billsPending: false,
        }
  
      case GESTION_OPERATIVA_ADD_BILLS_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          billsError: null,
          billsAction: null,
          billsPending: false,
        }
  
      case GESTION_OPERATIVA_ADD_BILLS_BEGIN:
        // Loading
        return {
          ...state,
          billsPending: true,
          billsAction: null,
          billsError: null
        }
  
      default:
        return state
    }
  }